import { render, staticRenderFns } from "./SendMessageBlock.vue?vue&type=template&id=09e33662&scoped=true"
import script from "./SendMessageBlock.vue?vue&type=script&lang=js"
export * from "./SendMessageBlock.vue?vue&type=script&lang=js"
import style0 from "./SendMessageBlock.vue?vue&type=style&index=0&id=09e33662&prod&lang=scss&scoped=true"
import style1 from "./SendMessageBlock.vue?vue&type=style&index=1&id=09e33662&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e33662",
  null
  
)

export default component.exports